const Status = {
    inProccessEnum: {
      Waiting: 'waiting',
      Processing: 'processing',
      NotCheckedIn: 'not-checked-in',
      CheckedIn: 'checked-in',
      Pending: 'pending',
    },
    canceledEnum: {
      NotPresent: 'not-present',
      Unsubscribe: 'unsubscribe',
      Canceled: 'canceled',
      Forwarded: 'forwarded',
      QueueClear: 'queue-clear',
      CronTask: 'daily-reset',
      NotCheckedIn: 'not-checked-in',
      Requeued: 'requeued',
      Retained: 'retained',
      Agenda: 'agenda',
    },
    completedEnum: {
      NotApproved: 'not-approved',
      Completed: 'completed',
      CheckInCompleted: 'check-in-completed',
    },
    displayNames: {
      Pending: 'pending',
      Waiting: 'waiting',
      Processing: 'processing',
      Completed: 'completed',
      NotApproved: 'not-approved',
      NotPresent: 'not-present',
      Forwarded: 'forwarded',
      DailyReset: 'daily-reset',
      QueueClear: 'queue-clear',
      Unsubscribe: 'unsubscribe',
      Requeued: 'requeued',
      Retained: 'retained',
      Expired: 'expired',
      Canceled: 'canceled',
    },
  };
  
  export default Status;
  